export default __webpack_public_path__ + "static/media/band7.62f56fa5.jfif";